import { HomeCTAButtons } from "./HomeCTAButtons";
import { HomeWrap } from "./HomeWrap";
import appScreen from "@/assets/home-app-screen.jpg";

interface Props {
  roundedTotal: number | null;
}

export function HomeHero({ roundedTotal }: Props) {
  return (
    <section className="py-[74px] pb-[78px] max-[820px]:py-11 max-[820px]:pb-[52px]">
      <HomeWrap className="grid items-center gap-11 min-[940px]:grid-cols-[1.06fr_.94fr] min-[940px]:gap-[68px]">
        <div>
          <h1 className="font-display text-[clamp(44px,6.4vw,70px)] font-semibold leading-[1.0] tracking-[-0.015em] text-[#3B2314]">
            Know which cafés you can actually work from
          </h1>
          <p className="mt-[22px] max-w-[42ch] text-xl leading-[1.5] text-[#7B4F2E]">
            Check the WiFi, outlets, seating and parking before you go, not after you've bought
            the coffee.
          </p>
          {/* Proof before the ask, stated once on the page. */}
          <p className="mt-[26px] text-[16.5px] font-semibold text-[#3B2314]">
            {roundedTotal !== null ? (
              <>
                Over {roundedTotal} cafés across Southern California,{" "}
                <span className="font-normal text-[#7B4F2E]">all scored the same way.</span>
              </>
            ) : (
              <span className="font-normal text-[#7B4F2E]">
                Every café across Southern California, scored the same way.
              </span>
            )}
          </p>
          <div data-hero-cta>
            <HomeCTAButtons className="mt-[22px]" />
          </div>
          <p className="mt-4 text-[13.5px] text-[#8A7563]">Free to download.</p>
        </div>

        {/* Phone frame, exactly as the design builds it. */}
        {/* Width is explicit, never max-width. With only a max-width this column
            is sized by its content, and the content is an image: until it
            decodes, its intrinsic width is 0, so the column collapses to 0 and
            the whole hero is 128px shorter than it ends up. That was the page's
            layout shift. A fixed width makes the img's `w-full` resolve on the
            first layout, which lets the width/height attributes reserve the
            box before any bytes arrive. */}
        <div className="relative ml-auto w-[320px] max-w-full max-[939px]:mx-auto max-[939px]:w-[290px]">
          <div className="relative rounded-[46px] bg-[#120C07] p-[9px] shadow-[0_50px_80px_-46px_rgba(28,19,12,.62),0_6px_16px_-8px_rgba(28,19,12,.28),inset_0_0_0_1.5px_rgba(255,255,255,.10)]">
            <div
              aria-hidden="true"
              className="absolute left-1/2 top-[9px] z-[3] h-6 w-[104px] -translate-x-1/2 rounded-b-[14px] bg-[#120C07]"
            />
            <div className="relative overflow-hidden rounded-[38px] bg-[#FAF8F5] pt-7">
              <img
                src={appScreen}
                alt="The Grounded app showing cafés near Encino, with Coral Tree Cafe scored 95."
                loading="eager"
                width={560}
                height={1137}
                className="block w-full"
              />
            </div>
          </div>
        </div>
      </HomeWrap>
    </section>
  );
}
